import { Toaster as Sonner } from 'sonner';
import { useTheme } from '@/lib/theme';

export { toast } from 'sonner';

export function Toaster() {
  const { theme } = useTheme();
  return (
    <Sonner
      theme={theme}
      position="top-right"
      // desce abaixo da faixa de impersonação (publica a altura em --imp-h); sem faixa vale 0
      offset={{ top: 'calc(var(--imp-h, 0px) + 16px)', right: 16 }}
      mobileOffset={{ top: 'calc(var(--imp-h, 0px) + 16px)', left: 12, right: 12 }}
      closeButton
      toastOptions={{
        classNames: {
          toast: '!rounded-[var(--radius-panel)] !border-border !bg-card !text-card-foreground !font-sans !shadow-[0_12px_32px_-12px_oklch(0.25_0.04_205/0.35)]',
          description: '!text-muted-foreground',
        },
      }}
    />
  );
}
